/* ============================================================================
   pers-cpc-overlay-auto.js — nakładka UI nad kalkulatorem naklejek na auto
   (calcid 6306cb16a5ecc).

   OSOBNY PLIK, NIE PARAMETR NAKŁADKI ARKUSZY. Oba kalkulatory mają inne pola,
   inne reguły i inną walidację: arkusze wymagają pliku, auto wymaga
   pliku ALBO napisu. Wspólny plik z rozgałęzieniem po calcid byłby dwoma
   programami w jednym — z ryzykiem, że poprawka dla jednego produktu
   wywróci drugi. Wspólne zostaje to, co naprawdę wspólne: wzorzec montażu,
   `pcv-on`, bramka min/max i technika chowania pól.

   ── CZERWONE LINIE ────────────────────────────────────────────────────────
   ZAPISUJEMY tylko przez trzy nazwane funkcje, każda z własnym uzasadnieniem:

     ustawLiczbe(input, wartosc)  — wymiary i nakład. Zakres z atrybutów
                                    min/max SAMEGO CPC. Wartość spoza zakresu
                                    jest ODRZUCANA, nie przycinana.
     ustawTekst(wartosc)          — pole napisu. Wyłącznie pusty łańcuch albo
                                    tekst wcześniej zapamiętany od użytkownika.
     wyczyscPlik()                — pole pliku i ukryte pole adresu, wyłącznie
                                    pustym łańcuchem, wyłącznie z przycisku
                                    „Usuń plik".

   Wybór w listach (kolor, czcionka) idzie przez `selectedIndex`, nie przez
   `.value` — opcje CPC nie mają atrybutu `value`.

   Dwa ostatnie zapisy to ŚWIADOME WYJĄTKI od pierwotnego zakazu „nigdy pole
   uploadu", wprowadzone punktem 6 ustaleń (`tools/cpc/auto/PUNKT-6-SCIEZKI.md`).
   Oba są cenowo obojętne: pole napisu nie występuje w formule, a pole pliku
   też nie. Żaden z nich nie może zmienić kwoty — i to jest powód, dla którego
   wyjątek jest bezpieczny.

   NIGDY: cena, #cpcPriceToken, #variantIdCustom, wysyłka formularza,
   przechwytywanie submit, wołanie PriceUpdation ani ChangeEvent wprost.

   ── CHOWANIE PÓL: PRZYCINANIE, NIGDY display:none ─────────────────────────
   `calculator.js` sprawdza `$(pole).is(":hidden")` i polu uznanemu za ukryte
   podstawia do formuły `value_when_not_displayed` (domyślnie 1) zamiast jego
   wartości. Pole `Materiał` niesie tu 450 (cena za metr), więc ukrycie go
   przez `display` dałoby cenę 450× niższą. Dlatego klasa `pcv-schowany`
   przycina kadrem 1×1 — jQuery widzi element jako widoczny.

   Awaria = strona bez nakładki, nie strona zepsuta: klasa `pcv-on` jest
   dokładana PO udanej budowie, a cały CSS wisi na niej.
   ============================================================================ */

(function () {
  'use strict';

  var KONF = document.getElementById('pcv-auto-konfiguracja');
  if (!KONF || KONF.dataset.wlaczona !== 'true') return;

  var T = {
    hint:        KONF.dataset.hint || '',
    strefa:      KONF.dataset.strefa || 'Masz gotowe logo? Wgraj plik',
    usun:        KONF.dataset.usun || 'Usuń plik',
    plikOk:      KONF.dataset.plikOk || 'Wydrukujemy Twój plik',
    tekstPrzyPliku: KONF.dataset.tekstPrzyPliku || '',
    brakObu:     KONF.dataset.brakObu || '',
    brakKroju:   KONF.dataset.brakKroju || '',
    ponadMax:    KONF.dataset.ponadMax || '',
    // Pusty lancuch znaczy „nie pokazuj przykladu". Nie podstawiamy tu zadnej
    // tresci awaryjnie: gdyby sekcja byla starsza niz ten asset, lepiej zeby
    // podglad byl pusty, niz zeby wymyslal klientowi napis.
    przyklad:    KONF.dataset.przyklad || '',
    naglKolor:   KONF.dataset.naglKolor || 'Kolor folii',
    naglFont:    KONF.dataset.naglFont || 'Rodzaj fontu',
    naglIlosc:   KONF.dataset.naglIlosc || 'Ilość sztuk',
    cta:         KONF.dataset.cta || 'Dodaj do koszyka',
    dostawa:     KONF.dataset.dostawa || ''
  };

  /* ---------------------------------------------------------------- montaż
     Kalkulator jest wstrzykiwany po stronie klienta — czekamy na jego POLA,
     nie na sam kontener. Wzorzec przejęty z nakładki arkuszy, gdzie brak tego
     czekania oznaczał nakładkę, która w ogóle się nie montowała.
     -------------------------------------------------------------------------- */

  var WYMAGANE_POLA = 4; // dwa wymiary + nakład + kolor; mniej = appka jeszcze buduje

  function gotowyKalkulator() {
    var k = document.getElementById('calculator');
    if (!k) return null;
    var pola = k.querySelectorAll('.element[data-element] input, .element[data-element] select, .element[data-element] textarea');
    return pola.length >= WYMAGANE_POLA ? k : null;
  }

  (function czekaj() {
    var k = gotowyKalkulator();
    if (k) { zbuduj(k); return; }
    var obs = new MutationObserver(function () {
      var k2 = gotowyKalkulator();
      if (!k2) return;
      obs.disconnect();
      clearTimeout(limit);
      zbuduj(k2);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    var limit = setTimeout(function () { obs.disconnect(); }, 15000);
  })();

  function zbuduj(kalkulator) {
    if (kalkulator.classList.contains('pcv-on')) return;

  /* ---------------------------------------------------------------- pomocnicze */

  function pole(wzorzec) {
    var boxy = kalkulator.querySelectorAll('.element[data-element]');
    for (var i = 0; i < boxy.length; i++) {
      if (wzorzec.test(boxy[i].getAttribute('data-element') || '')) return boxy[i];
    }
    return null;
  }

  function el(tag, klasa, tekst) {
    var e = document.createElement(tag);
    if (klasa) e.className = klasa;
    if (tekst != null) e.textContent = tekst;
    return e;
  }

  function przycisk(klasa, tekst) {
    var b = el('button', klasa, tekst);
    b.type = 'button';
    return b;
  }

  // Wyzwolenie przeliczenia. Zdarzenie ponawiane po chwili — obserwowany
  // jednorazowy wyścig z aplikacją, opisany w nakładce arkuszy.
  function przelicz(node) {
    node.dispatchEvent(new Event('input', { bubbles: true }));
    node.dispatchEvent(new Event('change', { bubbles: true }));
    setTimeout(function () {
      node.dispatchEvent(new Event('change', { bubbles: true }));
    }, 150);
  }

  function wZakresie(input, wartosc) {
    var min = parseFloat(input.getAttribute('min'));
    var max = parseFloat(input.getAttribute('max'));
    if (isFinite(min) && wartosc < min) return false;
    if (isFinite(max) && wartosc > max) return false;
    return true;
  }

  function liczbaZPola(input) {
    var v = parseFloat(String(input && input.value).replace(',', '.'));
    return isFinite(v) ? v : NaN;
  }

  /* ============================ ZAPIS 1/3 — pola liczbowe ==================
     Zakres z atrybutów samego CPC, nie z własnej listy. Wartość spoza zakresu
     odrzucamy: ciche przycięcie dałoby użytkownikowi inną liczbę niż kliknął. */
  function ustawLiczbe(input, wartosc) {
    if (!input || !isFinite(wartosc)) return false;
    var min = parseFloat(input.getAttribute('min'));
    var max = parseFloat(input.getAttribute('max'));
    if (isFinite(min) && wartosc < min) return false;
    if (isFinite(max) && wartosc > max) return false;
    input.value = String(wartosc);
    przelicz(input);
    return true;
  }

  // Wybór w liście — przez indeks, bo opcje CPC nie mają atrybutu `value`.
  function ustawWybor(select, indeks) {
    if (!select || indeks < 0 || indeks >= select.options.length) return false;
    select.selectedIndex = indeks;
    przelicz(select);
    return true;
  }

  /* ---------------------------------------------------------------- pola CPC */

  var boxTekst = pole(/napis|tekst/i);
  var boxKolor = pole(/kolor/i);
  var boxFont  = pole(/czcionk|font/i);
  var boxWys   = pole(/wysok/i);
  var boxSzer  = pole(/szerok/i);
  var boxNakl  = pole(/nak\w?ad/i);
  var boxMat   = pole(/materia/i);

  var inpPlik  = kalkulator.querySelector('input[type="file"]');
  var boxPlik  = inpPlik && inpPlik.closest ? inpPlik.closest('.element') : null;
  var inpAdres = kalkulator.querySelector('.cpc-file-url-input');

  // Bez wymiarów nie ma czego ubierać — wychodzimy, zostawiając czyste CPC.
  if (!boxWys || !boxSzer) return;
  var inpWys  = boxWys.querySelector('input');
  var inpSzer = boxSzer.querySelector('input');
  if (!inpWys || !inpSzer) return;

  var inpNakl = boxNakl ? boxNakl.querySelector('input') : null;
  var taTekst = boxTekst ? boxTekst.querySelector('textarea') : null;
  var selKolor = boxKolor ? boxKolor.querySelector('select') : null;
  // Pole czcionki może jeszcze nie istnieć — dokłada je Wiktor w panelu CPC.
  // Wtedy blok krojów po prostu się nie renderuje, a walidacja kroju milczy.
  var selFont = boxFont ? boxFont.querySelector('select') : null;

  var doOdswiezenia = [];

  /* ============================ ZAPIS 2/3 — pole napisu ====================
     Wyłącznie pusty łańcuch (czyszczenie po wgraniu pliku) albo tekst
     wcześniej zapamiętany od użytkownika (przywracanie po usunięciu pliku).
     Nigdy wartość wymyślona przez nakładkę. Pole nie występuje w formule,
     więc zapis nie może ruszyć ceny. */
  function ustawTekst(wartosc) {
    if (!taTekst) return false;
    taTekst.value = wartosc;
    przelicz(taTekst);
    return true;
  }

  /* ============================ ZAPIS 3/3 — pole pliku =====================
     Wyłącznie pustym łańcuchem i wyłącznie z przycisku „Usuń plik".
     Bez tego przycisku ścieżka powrotna nie istnieje: natywne okno wyboru
     pliku nie ma opcji „nic", a anulowanie zostawia poprzedni plik.
     Czyścimy OBA pola — samo `input[type=file]` nie wystarczy, bo aplikacja
     czyta adres z ukrytego `.cpc-file-url-input`. */
  function wyczyscPlik() {
    if (inpPlik) { inpPlik.value = ''; }
    if (inpAdres) { inpAdres.value = ''; }
    // ŚWIADOMIE bez `przelicz`. Pole pliku nie występuje w formule, więc nie ma
    // czego przeliczać, a `change` na pustym polu pliku wpuściłby aplikację
    // w jej procedurę wgrywania bez pliku. Nie zaczepiamy cudzego kodu bez potrzeby.
    return true;
  }

  /* ------------------------------------------------------- stan ścieżek */

  // Pamięć tego, co użytkownik napisał, zanim wgrał plik. Trzymana w zmiennej,
  // NIE w polu — pole ma być puste, bo puste jedzie do koszyka.
  var zapamietane = { tekst: '', font: -1 };
  var maPlik = false;

  function plikObecny() {
    var zPola = inpPlik && inpPlik.files && inpPlik.files.length > 0;
    var zAdresu = inpAdres && String(inpAdres.value || '').trim() !== '';
    return !!(zPola || zAdresu);
  }

  function tekstObecny() {
    return !!(taTekst && String(taTekst.value || '').trim() !== '');
  }

  // Indeks 0 to „— nie dotyczy —". Porównujemy po pozycji i po fragmencie
  // nazwy, nigdy znak w znak: etykietę wpisuje człowiek w panelu, a myślnik
  // ma trzy popularne warianty.
  function krojWybrany() {
    if (!selFont) return true;               // brak pola = nie ma czego wymagać
    if (selFont.selectedIndex <= 0) return false;
    var opcja = selFont.options[selFont.selectedIndex];
    var napis = (opcja.getAttribute('data-label') || opcja.textContent || '').toLowerCase();
    return napis.indexOf('nie dotyczy') === -1;
  }

  /* ---------------------------------------------------------------- podgląd */

  var podglad = el('div', 'pcv-podglad');
  var podgladTekst = el('span', 'pcv-podglad__tekst');
  podglad.appendChild(podgladTekst);
  podglad.setAttribute('aria-hidden', 'true');   // to ilustracja, nie treść

  // Kolory folii rozpoznajemy po NAZWIE opcji, bo CPC nie niesie próbki barwy.
  // Nazwy pochodzą z enumeracji pola, nie z wyobraźni: Czarny / Biały / Czerwony.
  var BARWY = [
    { wzor: /czarn/i,   folia: '#111111', tlo: '#f2eef8', ciemne: false },
    { wzor: /bia[łl]/i, folia: '#ffffff', tlo: '#2b2b2b', ciemne: true  },
    { wzor: /czerwon/i, folia: '#d0021b', tlo: '#f2eef8', ciemne: false }
  ];

  function barwaOpcji(napis) {
    for (var i = 0; i < BARWY.length; i++) {
      if (BARWY[i].wzor.test(napis)) return BARWY[i];
    }
    // Nieznana nazwa koloru: rysujemy neutralnie, zamiast zgadywać barwę.
    return { folia: '#444444', tlo: '#f2eef8', ciemne: false };
  }

  function aktualnaBarwa() {
    if (!selKolor || selKolor.selectedIndex < 0) return barwaOpcji('');
    var o = selKolor.options[selKolor.selectedIndex];
    return barwaOpcji((o.getAttribute('data-label') || o.textContent || ''));
  }

  var FONTY = ['--pcv-font-1', '--pcv-font-2', '--pcv-font-3', '--pcv-font-4'];

  function odswiezPodglad() {
    var b = aktualnaBarwa();
    podglad.style.background = b.tlo;
    podglad.classList.toggle('pcv-podglad--ciemny', !!b.ciemne);
    podgladTekst.style.color = b.folia;

    // Krój: opcja 1 z listy CPC to „— nie dotyczy —", więc pozycja N w liście
    // odpowiada zmiennej --pcv-font-N. Gdy pola nie ma, zostaje krój pierwszy.
    var i = selFont ? selFont.selectedIndex - 1 : 0;
    if (i < 0 || i >= FONTY.length) i = 0;
    podgladTekst.style.fontFamily = 'var(' + FONTY[i] + ')';

    // TEKST PRZYKLADOWY — wylacznie ilustracja pustego pola.
    //
    // Zyje TYLKO w elemencie podgladu: nie jest wpisywany do textarea, nie idzie
    // do properties zamowienia i nie liczy sie do walidacji jedno-z-dwojga.
    // `tekstObecny()` czyta `taTekst.value`, ktorego ta funkcja nie dotyka, wiec
    // „Twoj wzor" na podgladzie NIE przepuszcza zakupu bez tresci.
    //
    // Nie pokazujemy go przy wgranym pliku: wtedy wygrywa sciezka plikowa
    // („Wydrukujemy Twoj plik") i przyklad sugerowalby, ze wydrukujemy napis.
    var tekst = taTekst ? String(taTekst.value || '') : '';
    var pusty = tekst.trim() === '';
    var przyklad = pusty && T.przyklad !== '' && !maPlik;

    podgladTekst.textContent = przyklad ? T.przyklad : (pusty ? '' : tekst);

    // Krój i kolor ustawiono wyżej, poza tym rozgałęzieniem — dzięki temu
    // przykład reaguje na przełączanie foliami i krojami tak samo jak wpisany
    // napis, bez drugiej ścieżki, która mogłaby się rozjechać.
    podglad.classList.toggle('pcv-podglad--pusty', pusty && !przyklad);
    podglad.classList.toggle('pcv-podglad--przyklad', przyklad);
  }
  doOdswiezenia.push(odswiezPodglad);

  /* ---------------------------------------------------------------- napis */

  var krokNapis = el('div', 'pcv-krok');
  krokNapis.appendChild(podglad);

  // Napis i plik stoją OBOK SIEBIE, po połowie szerokości — układ ma mówić
  // „albo-albo" samym kształtem, zanim klient przeczyta którykolwiek komunikat.
  // Sekwencja pionowa sugerowała kolejne kroki do wykonania po sobie.
  var para = el('div', 'pcv-para');
  var kolTekst = el('div', 'pcv-para__kol');
  para.appendChild(kolTekst);
  krokNapis.appendChild(para);

  if (boxTekst && taTekst) {
    // Etykieta CPC brzmi „Lub wpisz napis który wytniemy" — sensownie tylko
    // wtedy, gdy upload stoi PRZED nią, a u nas napis jest pierwszy.
    // Chowamy ją przycięciem i dajemy polu własną nazwę dla czytnika ekranu.
    var etykietaCPC = boxTekst.querySelector('label');
    if (etykietaCPC) etykietaCPC.classList.add('pcv-schowany');
    taTekst.setAttribute('aria-label', 'Napis na naklejce');
    kolTekst.appendChild(boxTekst);
    boxTekst.classList.add('pcv-pole-napis');

    taTekst.addEventListener('input', function () {
      odswiezPodglad();
      // Kierunek zabroniony: tekst przy wgranym pliku NIE kasuje pliku.
      // Plik to świadomy upload, tekst mógł być odruchem — więc tylko mówimy,
      // co się dzieje, i zostawiamy decyzję użytkownikowi.
      pokazUwage(maPlik && tekstObecny() ? T.tekstPrzyPliku : '');
    });
  }

  var uwaga = el('p', 'pcv-uwaga');
  uwaga.hidden = true;
  kolTekst.appendChild(uwaga);
  function pokazUwage(tekst) {
    if (!tekst) { uwaga.hidden = true; return; }
    uwaga.textContent = tekst;
    uwaga.hidden = false;
  }

  if (T.hint) kolTekst.appendChild(el('p', 'pcv-hint', T.hint));

  /* ---------------------------------------------------------------- plik */

  var strefa = null, statusPliku = null, btnUsun = null;

  if (boxPlik && inpPlik) {
    strefa = el('div', 'pcv-strefa pcv-para__kol');
    var opisStrefy = el('span', 'pcv-strefa__opis', T.strefa);
    strefa.appendChild(opisStrefy);
    strefa.appendChild(boxPlik);
    boxPlik.classList.add('pcv-pole-plik');

    statusPliku = el('p', 'pcv-strefa__status');
    statusPliku.hidden = true;
    strefa.appendChild(statusPliku);

    btnUsun = przycisk('pcv-usun', T.usun);
    btnUsun.hidden = true;
    btnUsun.addEventListener('click', function () {
      wyczyscPlik();
      // „Kreator wraca" znaczy: wraca z tym, co w nim było. Przywracamy tekst
      // i krój zapamiętane przed wgraniem — inaczej użytkownik traci swoją
      // pracę bez cofnięcia, a jedynym powodem byłaby nasza wygoda.
      if (zapamietane.tekst) ustawTekst(zapamietane.tekst);
      if (selFont && zapamietane.font > 0) ustawWybor(selFont, zapamietane.font);
      zapamietane = { tekst: '', font: -1 };
      stanPliku(false);
      odswiez();
    });
    strefa.appendChild(btnUsun);

    // Wyszarzenie leci NATYCHMIAST po wyborze pliku — użytkownik ma od razu
    // widzieć, że ścieżka się przełączyła.
    inpPlik.addEventListener('change', function () {
      if (inpPlik.files && inpPlik.files.length) stanPliku(true);
      else stanPliku(false);
    });

    // CZYSZCZENIE dopiero po POTWIERDZENIU wgrania, czyli po wypełnieniu
    // ukrytego pola adresu przez aplikację. Gdybyśmy czyścili na `change`,
    // nieudany upload kasowałby napis bez żadnego zysku.
    if (inpAdres) {
      new MutationObserver(sprawdzAdres).observe(inpAdres, { attributes: true, attributeFilter: ['value'] });
      inpAdres.addEventListener('change', sprawdzAdres);
      // Aplikacja ustawia `.value` z JS, co nie zawsze rusza atrybut ani nie
      // wysyła zdarzenia — dlatego dodatkowo odpytujemy przez chwilę po zmianie.
      inpPlik.addEventListener('change', function () {
        var prob = 0;
        var tik = setInterval(function () {
          sprawdzAdres();
          if (++prob > 40 || !plikObecny()) clearInterval(tik);
        }, 500);
      });
    }
  }

  function sprawdzAdres() {
    if (!plikObecny()) return;
    if (!zapamietane.tekst && tekstObecny()) {
      zapamietane.tekst = String(taTekst.value);
      zapamietane.font = selFont ? selFont.selectedIndex : -1;
    }
    if (tekstObecny()) ustawTekst('');
    if (selFont && selFont.selectedIndex !== 0) ustawWybor(selFont, 0);
    stanPliku(true);
    odswiez();
  }

  function stanPliku(jest) {
    maPlik = jest;
    if (statusPliku) {
      statusPliku.textContent = jest ? T.plikOk : '';
      statusPliku.hidden = !jest;
    }
    if (btnUsun) btnUsun.hidden = !jest;
    // Wyszarzenie jest WIZUALNE i obejmuje TYLKO połówkę tekstową — podgląd
    // zostaje czytelny, a strefa pliku, która właśnie wygrała, nie może gasnąć
    // razem z tym, co przykrywa.
    // Pola nie blokujemy: punkt 6 przewiduje, że użytkownik może zacząć pisać
    // mimo wgranego pliku — wtedy dostaje uwagę, a nie zablokowaną klawiaturę.
    kolTekst.classList.toggle('pcv-krok--wyszarzony', jest);
    if (blokFont) blokFont.classList.toggle('pcv-krok--wyszarzony', jest);
    if (!jest) pokazUwage('');
    // Przyklad w podgladzie zalezy od obecnosci pliku, wiec odswiezamy go TU,
    // a nie licząc na to, że każdy przyszły wywołujący `stanPliku` pamięta
    // o dołożeniu `odswiez()` po swojej stronie.
    odswiezPodglad();
  }

  /* ---------------------------------------------------------------- kolor */

  function grupaKoloru() {
    if (!selKolor || !selKolor.options.length) return null;
    var krok = el('div', 'pcv-krok');
    krok.appendChild(el('span', 'pcv-krok__nr', T.naglKolor));

    var grupa = el('div', 'pcv-swatche');
    grupa.setAttribute('role', 'group');
    grupa.setAttribute('aria-label', T.naglKolor);

    var przyciski = [];
    for (var i = 0; i < selKolor.options.length; i++) {
      (function (indeks) {
        var o = selKolor.options[indeks];
        var napis = (o.getAttribute('data-label') || o.textContent || '').trim();
        var barwa = barwaOpcji(napis);

        var b = przycisk('pcv-swatch');
        var kwadrat = el('span', 'pcv-swatch__kolor');
        kwadrat.style.background = barwa.folia;
        b.appendChild(kwadrat);
        // Nazwa pod kwadratem, nie sam kwadrat: biała folia na białym tle to
        // sama ramka, a czerń i granat w tej skali są nierozróżnialne.
        b.appendChild(el('span', 'pcv-swatch__nazwa', napis));
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () { ustawWybor(selKolor, indeks); odswiez(); });
        przyciski.push(b);
        grupa.appendChild(b);
      })(i);
    }
    krok.appendChild(grupa);

    doOdswiezenia.push(function () {
      przyciski.forEach(function (b, i) {
        var akt = selKolor.selectedIndex === i;
        b.classList.toggle('pcv--aktywny', akt);
        b.setAttribute('aria-pressed', akt ? 'true' : 'false');
      });
    });

    boxKolor.classList.add('pcv-schowany');
    selKolor.setAttribute('tabindex', '-1');
    return krok;
  }

  /* ---------------------------------------------------------------- czcionka */

  var blokFont = null;

  function grupaFontu() {
    // Pola nie ma dopóki Wiktor nie doda go w panelu — wtedy bloku po prostu
    // nie ma, a walidacja kroju nie ma czego wymagać.
    if (!selFont || selFont.options.length < 2) return null;

    var krok = el('div', 'pcv-krok');
    krok.appendChild(el('span', 'pcv-krok__nr', T.naglFont));

    var grupa = el('div', 'pcv-fonty');
    grupa.setAttribute('role', 'group');
    grupa.setAttribute('aria-label', T.naglFont);

    var przyciski = [];
    // Od 1, nie od 0: opcja zerowa to „— nie dotyczy —", stan wewnętrzny,
    // nie wybór do klikania.
    for (var i = 1; i < selFont.options.length; i++) {
      (function (indeks) {
        var o = selFont.options[indeks];
        var napis = (o.getAttribute('data-label') || o.textContent || '').trim();
        var b = przycisk('pcv-font');
        var proba = el('span', 'pcv-font__aa', 'Aa');
        var zmienna = FONTY[indeks - 1];
        if (zmienna) proba.style.fontFamily = 'var(' + zmienna + ')';
        b.appendChild(proba);
        b.appendChild(el('span', 'pcv-font__nazwa', napis));
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () { ustawWybor(selFont, indeks); odswiez(); });
        przyciski.push({ btn: b, i: indeks });
        grupa.appendChild(b);
      })(i);
    }
    krok.appendChild(grupa);

    doOdswiezenia.push(function () {
      przyciski.forEach(function (p) {
        var akt = selFont.selectedIndex === p.i;
        p.btn.classList.toggle('pcv--aktywny', akt);
        p.btn.setAttribute('aria-pressed', akt ? 'true' : 'false');
      });
    });

    boxFont.classList.add('pcv-schowany');
    selFont.setAttribute('tabindex', '-1');
    blokFont = krok;
    return krok;
  }

  /* ---------------------------------------------------------------- wymiary */

  function krokWymiarow() {
    var krok = el('div', 'pcv-krok');
    var rzad = el('div', 'pcv-rzad');
    // Kolejność z makiety: wysokość po lewej, szerokość po prawej.
    rzad.appendChild(boxWys);
    rzad.appendChild(boxSzer);
    krok.appendChild(rzad);
    return krok;
  }

  /* ---------------------------------------------------------------- ilość */

  function krokIlosci() {
    if (!inpNakl) return null;

    var krok = el('div', 'pcv-krok');
    var glowa = el('div', 'pcv-ilosc__glowa');
    glowa.appendChild(el('span', 'pcv-krok__nr', T.naglIlosc));

    var stepper = el('div', 'pcv-stepper');
    var minus = przycisk('pcv-stepper__btn', '−');
    var plus  = przycisk('pcv-stepper__btn', '+');
    minus.setAttribute('aria-label', 'Mniej sztuk');
    plus.setAttribute('aria-label', 'Więcej sztuk');

    var krokWartosci = parseFloat(inpNakl.getAttribute('step'));
    if (!isFinite(krokWartosci) || krokWartosci <= 0) krokWartosci = 1;

    function przesun(kierunek) {
      var teraz = liczbaZPola(inpNakl);
      if (!isFinite(teraz)) teraz = parseFloat(inpNakl.getAttribute('min')) || 0;
      // ustawLiczbe odrzuci wyjście poza min/max — przycisk po prostu nic
      // nie zrobi na krańcu zakresu, zamiast wpisywać wartość nie do przyjęcia.
      ustawLiczbe(inpNakl, teraz + kierunek * krokWartosci);
      odswiez();
    }
    minus.addEventListener('click', function () { przesun(-1); });
    plus.addEventListener('click', function () { przesun(1); });

    stepper.appendChild(minus);
    stepper.appendChild(boxNakl);
    boxNakl.classList.add('pcv-pole-ilosc');
    stepper.appendChild(plus);
    glowa.appendChild(stepper);
    krok.appendChild(glowa);

    // Chipy proponowanych ilości. Bez procentów — progi cenowe istnieją
    // w kalkulatorze, ale ich NIE komunikujemy (decyzja architekta).
    var chipy = [];
    var pas = el('div', 'pcv-chipy');
    String(KONF.dataset.chipy || '').split(',').forEach(function (kawalek) {
      var n = parseInt(kawalek.trim(), 10);
      if (!isFinite(n)) return;
      // Chip poza zakresem CPC w ogóle się nie renderuje — użytkownik nie może
      // kliknąć wartości, której kalkulator i tak by nie przyjął.
      if (!wZakresie(inpNakl, n)) return;
      var b = przycisk('pcv-chip', String(n));
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () { ustawLiczbe(inpNakl, n); odswiez(); });
      chipy.push({ btn: b, n: n });
      pas.appendChild(b);
    });
    if (chipy.length) {
      // Chipy w TEJ SAMEJ linii co stepper, po jego prawej — kalkulator ma być
      // niższy. Na wąskim ekranie `flex-wrap` na główce zrzuca cały pas chipów
      // pod stepper, w jednym kawałku, bo to osobny kontener.
      glowa.appendChild(pas);
      doOdswiezenia.push(function () {
        var akt = liczbaZPola(inpNakl);
        chipy.forEach(function (c) {
          var a = c.n === akt;
          c.btn.classList.toggle('pcv--aktywny', a);
          c.btn.setAttribute('aria-pressed', a ? 'true' : 'false');
        });
      });
    }

    doOdswiezenia.push(function () {
      var teraz = liczbaZPola(inpNakl);
      var min = parseFloat(inpNakl.getAttribute('min'));
      var max = parseFloat(inpNakl.getAttribute('max'));
      minus.disabled = isFinite(min) && isFinite(teraz) && teraz - krokWartosci < min;
      plus.disabled  = isFinite(max) && isFinite(teraz) && teraz + krokWartosci > max;
    });

    return krok;
  }

  /* ---------------------------------------------------------------- walidacja */

  // Jedno źródło prawdy dla obu naszych przycisków: CTA nakładki i paska
  // dolnego. Zwraca komunikat do pokazania albo pusty łańcuch, gdy można kupić.
  function walidujZakup() {
    var maxNakl = parseFloat(inpNakl && inpNakl.getAttribute('max'));
    var terazNakl = liczbaZPola(inpNakl);
    if (isFinite(maxNakl) && isFinite(terazNakl) && terazNakl > maxNakl) {
      return { komunikat: String(T.ponadMax).replace('{max}', maxNakl), cel: inpNakl };
    }
    if (!tekstObecny() && !plikObecny()) {
      return { komunikat: T.brakObu, cel: taTekst || inpPlik };
    }
    // Obie ścieżki naraz. Punkt 6 mówi „jedno z dwóch", więc przepuszczenie
    // tego stanu wysłałoby na produkcję plik I napis — bez informacji, co jest
    // czym. Blokujemy i kierujemy do pliku, bo tam stoi przycisk „Usuń plik".
    //
    // Wcześniej ten stan wpadał niżej i dostawał komunikat „Wybierz rodzaj
    // czcionki": blokada padała z właściwego powodu, ale mówiła nie to, co
    // trzeba — klient miał gotowy plik i słyszał, że ma wybrać krój.
    if (tekstObecny() && plikObecny()) {
      return { komunikat: T.tekstPrzyPliku, cel: inpPlik || taTekst };
    }
    if (tekstObecny() && !krojWybrany()) {
      return { komunikat: T.brakKroju, cel: blokFont || taTekst };
    }
    return null;
  }

  var blad = el('p', 'pcv-blad');
  blad.setAttribute('role', 'alert');
  blad.hidden = true;

  function pokazBlad(wynik) {
    if (!wynik) { blad.hidden = true; return; }
    blad.textContent = wynik.komunikat;
    blad.hidden = false;
    if (wynik.cel && typeof wynik.cel.scrollIntoView === 'function') {
      wynik.cel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (wynik.cel && typeof wynik.cel.focus === 'function') {
      wynik.cel.focus({ preventScroll: true });
    }
  }

  // Pasek dolny pyta nas o zgodę zdarzeniem odwoływalnym. Bez nasłuchu (arkusze)
  // pasek działa dokładnie jak dotąd — to jest dodatek, nie zmiana zachowania.
  document.addEventListener('pers:przed-zakupem', function (e) {
    // Meldujemy, że walidację przejęliśmy — pasek ma wtedy odpuścić własną,
    // awaryjną kontrolę obecności pliku. Na tym produkcie plik jest opcjonalny.
    if (e.detail) e.detail.obsluzone = true;
    var wynik = walidujZakup();
    if (!wynik) return;
    e.preventDefault();
    pokazBlad(wynik);
  });

  /* ---------------------------------------------------------------- CTA */

  var natywny = document.querySelector('#main-product .product-form__submit');

  function ctaNakladki() {
    if (!natywny) return null;
    var stopka = el('div', 'pcv-stopka');
    stopka.appendChild(blad);

    var b = przycisk('pcv-cta', T.cta);
    b.setAttribute('data-pers-kotwica-paska', '');
    b.addEventListener('click', function () {
      var wynik = walidujZakup();
      if (wynik) { pokazBlad(wynik); return; }
      blad.hidden = true;
      // Proxy, nie własny submit: walidacja aplikacji ma zadziałać dokładnie
      // tak, jak przy kliknięciu w oryginał.
      natywny.click();
    });
    stopka.appendChild(b);

    if (T.dostawa) stopka.appendChild(el('p', 'pcv-dostawa', T.dostawa));
    return stopka;
  }

  /* ---------------------------------------------------------------- budowa */

  function odswiez() {
    for (var i = 0; i < doOdswiezenia.length; i++) doOdswiezenia[i]();
  }

  var blokKolor = grupaKoloru();
  grupaFontu();                    // ustawia blokFont albo zostawia null
  var blokWymiar = krokWymiarow();
  var blokIlosc = krokIlosci();
  var blokCta = ctaNakladki();

  // Materiał ma jedną opcję — nie ma czego wybierać, więc znika z widoku.
  // PRZYCIĘCIEM, nie display:none: niesie 450 w formule i ukrycie przez
  // display podstawiłoby tam 1, czyli cenę 450 razy niższą.
  if (boxMat) {
    boxMat.classList.add('pcv-schowany');
    var selMat = boxMat.querySelector('select');
    if (selMat) selMat.setAttribute('tabindex', '-1');
  }

  // Strefa pliku wchodzi jako druga kolumna pary, nie jako osobny blok.
  if (strefa) para.appendChild(strefa);
  else para.classList.add('pcv-para--sama');

  var kotwica = kalkulator.firstElementChild;
  [krokNapis, blokKolor, blokFont, blokWymiar, blokIlosc].forEach(function (b) {
    if (b) kalkulator.insertBefore(b, kotwica);
  });
  // Stopka z CTA idzie na koniec, pod pasek ceny aplikacji.
  if (blokCta) kalkulator.appendChild(blokCta);

  // Sync w drugą stronę: ręczna zmiana pola odświeża podświetlenia i podgląd.
  [inpSzer, inpWys, inpNakl, selKolor, selFont, taTekst].forEach(function (k) {
    if (!k) return;
    k.addEventListener('input', odswiez);
    k.addEventListener('change', odswiez);
  });

  stanPliku(plikObecny());
  odswiez();

  // Dopiero teraz CSS nakładki zaczyna działać. Wyjątek wyżej = czyste CPC.
  kalkulator.classList.add('pcv-on');

  } /* zbuduj */
})();
